import { render } from "./other-funds.vue?vue&type=template&id=3dbab388&scoped=true"
import script from "./other-funds.vue?vue&type=script&lang=js"
export * from "./other-funds.vue?vue&type=script&lang=js"

import "./other-funds.vue?vue&type=style&index=0&id=3dbab388&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dbab388"]])

export default __exports__